import { render, staticRenderFns } from "./CatalogsColumnsModal.vue?vue&type=template&id=339c88f2&scoped=true"
import script from "./CatalogsColumnsModal.vue?vue&type=script&lang=js"
export * from "./CatalogsColumnsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339c88f2",
  null
  
)

export default component.exports